import React from 'react';
import PropTypes from 'prop-types';

import styles from './Checkbox.module.scss';

const Checkbox = React.forwardRef(({ label, errors, ...defaultProps }, ref) => {
	return (
		<div className={styles.wrapper}>
			<input className={styles.input} ref={ref} type='checkbox' {...defaultProps} />
			<label className={styles.label} htmlFor={defaultProps.id}>{label}</label>
		</div>
	);
});

Checkbox.propTypes = {
	label: PropTypes.any.isRequired,
	errors: PropTypes.object,
};

export default Checkbox;
